import { MutationCache, QueryCache, QueryClient, VueQueryPlugin } from '@tanstack/vue-query';

import { CLIENT_ACCESS_ERROR_CODES, NETWORK_ERROR_CODES } from '@/utils/errors.utils';

export default defineNuxtPlugin((app) => {
  const { $toast, $i18n } = useNuxtApp();

  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error: unknown) => {
        if (!import.meta.client) return;
        const { statusCode, key } = normalizeErrorToI18n(error);

        if (!statusCode || statusCode >= 500 || CLIENT_ACCESS_ERROR_CODES.includes(statusCode)) {
          $toast.error($i18n.t(key));
        }
      },
    }),

    mutationCache: new MutationCache({
      onError: (error: unknown) => {
        if (!import.meta.client) return;
        const { statusCode, key } = normalizeErrorToI18n(error);
        if (!statusCode || statusCode >= 500 || CLIENT_ACCESS_ERROR_CODES.includes(statusCode)) {
          $toast.error($i18n.t(key));
        }
      },
    }),

    defaultOptions: {
      queries: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        retry: (failureCount, error: any) => {
          if (failureCount > 2) return false;
          const code = error?.code ?? error?.response?.status;
          return NETWORK_ERROR_CODES.includes(code);
        },
        retryDelay: attemptIndex => Math.pow(3, attemptIndex) * 100,
      },
    },
  });

  app.vueApp.use(VueQueryPlugin, { queryClient });
});
